import axios from 'axios';

import { useQuery } from 'react-query';

export default function useGetEquipmentByTagNr(equipmentType) {
  const { data, isFetching, error } = useQuery(
    ['equipmentByTagNr', { tagNr: equipmentType }],
    async () => (await axios.get(`/idcards/equipment/${equipmentType}`)).data,
    {
      enabled: !!equipmentType,
    }
  );

  return {
    equipment: data,
    isLoading: isFetching,
    error,
  };
}
